import { render, staticRenderFns } from "./ModalToRequestInfoAboutSifaApp.vue?vue&type=template&id=1bc50622"
import script from "./ModalToRequestInfoAboutSifaApp.vue?vue&type=script&lang=js"
export * from "./ModalToRequestInfoAboutSifaApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports